import { CONFIGURATION } from "utils/constants";

const baseUrl = CONFIGURATION.baseUrl;

//Auth
export const SIGNIN_SOCIAL = `${baseUrl}/signup/social`;
export const SIGNIN_EMAIL = `${baseUrl}/signin/email`;
export const REGISTER_VIA_EMAIL = `${baseUrl}/signup/email`;
export const VERIFY_EMAIL = `${baseUrl}/verify/email`;
export const RESET_PASSWORD_EMAIL_SUBMIT = `${baseUrl}/password/reset/email`;
export const RESET_PASSWORD_EMAIL_VERIFY = `${baseUrl}/reset/password`;
export const RESET_PASSWORD = `${baseUrl}/password/change`;
export const AUTH_PROFILE = `${baseUrl}/auth/profile`;
export const AUTH_USER_GET = `${baseUrl}/auth/user/profile/get`;

export const EXPERT_PROFILE_GET = `${baseUrl}/auth/teacher/profile/get`;
export const EXPERT_PROFILE_CREATE = `${baseUrl}/auth/teacher`;
export const EXPERT_PROFILE_UPDATE = `${baseUrl}/auth/teacher/update`;
export const GET_TEACHER_BY_ID = `${baseUrl}/auth/teacher`;

export const SINGLE_LESSON_PUBLISH_UNPUBLISH = `${baseUrl}/auth/expert/lessons/single/status/change`;
export const LESSON_PUBLISH_UNPUBLISH = `${baseUrl}/auth/lesson/status/change`;
export const LESSONS_CREATE = `${baseUrl}/auth/lesson`;
export const LESSONS_UPDATE = `${baseUrl}/auth/lesson/update`;
export const LESSONS_GET = `${baseUrl}/auth/lesson`;
export const RESERVED_LESSONS_GET = `${baseUrl}/auth/reservation`;

export const PACK_LESSON_PUBLISH_UNPUBLISH = `${baseUrl}/auth/expert/lessons/pack/status/change`;

export const SAVE_BANK_DETAILS = `${baseUrl}/auth/teacher/bank/register`;
export const GET_BANK_DETAILS = `${baseUrl}/auth/teacher/bank/get`;

//Common
export const GET_EXPERT_COUNTRIES = `${baseUrl}/common/countries/expert/available`;
export const GET_EXPERT_COUNTRIES_FLAT = `${baseUrl}/common/countries/expert/available/flat`;
export const GET_FAMOUS_EXPERTS = `${baseUrl}/common/expert/famous`;
export const GET_NEW_COMER_EXPERTS = `${baseUrl}/common/expert/recently`;
export const GET_COUNTRY_WISE_EXPERTS = `${baseUrl}/common/countries/experts`;
export const COUNTRIES_GET = `${baseUrl}/common/get/countries`;
export const CATEGORIES_GET = `${baseUrl}/common/get/categories`;
export const GET_ALL_EXPERTS = `${baseUrl}/auth/teacher/filter`; // * get all experts
export const GET_HOME_NOTICES = `${baseUrl}/common/notice/show`;
export const GET_EXPERT_COUNT = `${baseUrl}/common/expert/total/count`;
export const GET_LANGUAGES = `${baseUrl}/common/get/language-list`;

//users
export const GET_FAVORITE_EXPERTS = `${baseUrl}/auth/user/expert/favorites`;
export const GET_BOOKMARKED_EXPERTS = `${baseUrl}/auth/teacher/bookmarked`;

//schedule
export const GET_ALL_SCHEDULES = `${baseUrl}/expert/schedules/getbyid`;
export const GET_ALL_SCHEDULE_BY_EXPERT_ID = `${baseUrl}/auth/schedule-times/getbyid`;
export const CREATE_SCHEDULES = `${baseUrl}/auth/expert/schedules/save`;
export const GET_SCHEDULE_TEMPLATE = `${baseUrl}/auth/expert/schedules/templete`;
export const ADD_SCHEDULE_TIME_SLOT = `${baseUrl}/auth/schedule/add`;
export const REMOVE_SCHEDULE_TIME_SLOT = `${baseUrl}/auth/schedule/delete`;

//Students
export const GET_MY_LESSONS = `${baseUrl}/auth/user/reservation`;
export const GET_RESERVED_LESSONS = `${baseUrl}/auth/user/reservations/requested`;
export const GET_NOT_USED_LESSONS = `${baseUrl}/auth/user/reservations/notused`;
export const GET_COMPLETED_LESSONS = `${baseUrl}/auth/user/reservations/completed`;
export const GET_GROUP_LESSONS = `${baseUrl}/auth/user/reservations/groups`;
export const STUDENT_LESSONS_FILTER = `${baseUrl}/auth/lesson/filter`;
export const GET_PAYMENT_INTENT = `${baseUrl}/auth/user/paymentintent`;
export const GET_POINTS_PLANS= `${baseUrl}/auth/user/points/get/plans`;
export const GET_PURCHASE_HISTORY = `${baseUrl}/auth/user/points/get/history`;

// reservations
export const GET_RESERVATIONS_INDIVIDUAL = `${baseUrl}/auth/expert/reservations/individual`;
export const GET_RESERVATIONS_GROUP = `${baseUrl}/auth/expert/reservations/group`;
export const APPROVE_SINGLE_LESSON = `${baseUrl}/auth/expert/reservations/action/single/approve`;
export const APPROVE_PACK_LESSON = `${baseUrl}/auth/expert/reservations/action/pack/approve`;
export const REJECT_PACK_LESSON = `${baseUrl}/auth/expert/reservations/action/pack/reject`;
export const GET_ENROLLMENTS_GROUP_SINGLE = `${baseUrl}/auth/expert/reservations/group/single/users`;
export const GET_ENROLLMENTS_GROUP_PACK = `${baseUrl}/auth/expert/reservations/group/pack/users`;
export const REQUEST_RESERVATION_SCHEDULE_CHANGE = `${baseUrl}/auth/reservation/request/schedule-change`;
export const TEACHER_RESERVATION_ACTION = `${baseUrl}/auth/reservation/action`;
export const TEACHER_SUBMIT_REPORT = `${baseUrl}/auth/reservation/submit-report`;
export const GROUP_LESSONS_RESERVATION_STUDENT_LIST = `${baseUrl}/auth/reservation/group/users`;

// * reject reservations
export const REJECT_RESERVATION_INDIVIDUAL_SINGLE = `${baseUrl}/auth/expert/reservations/action/single/individual/reject`;
export const REJECT_RESERVATION_INDIVIDUAL_PACK = `${baseUrl}/auth/expert/reservations/action/pack/individual/reject`;
export const REJECT_RESERVATION_GROUP_SINGLE_AND_PACK = `${baseUrl}/auth/expert/reservations/action/pack/reject`;

// * cancel reservations
export const CANCEL_RESERVATION_GROUP_SINGLE_AND_PACK = `${baseUrl}/auth/user/reservations/pack/cancel`;
export const CANCEL_RESERVATION_INDIVIDUAL_PACK = `${baseUrl}/auth/user/reservations/single/pack/cancel`;
export const CANCEL_RESERVATION_INDIVIDUAL_SINGLE = `${baseUrl}/auth/user/reservations/single/inividual/cancel`;

// * profile
export const EDIT_PROFILE = `${baseUrl}/auth/profile`;

//experts
export const GET_EXPERT_BY_ID = `${baseUrl}/expert/profile/get`;

// * get lesson by id
export const GET_LESSON_BY_ID = `${baseUrl}/user/get/lessonById`;
export const GET_LESSON = `${baseUrl}/auth/user/get/lesson`;
export const TEACHER_GET_LESSON = `${baseUrl}/auth/lesson/show`;
export const RESERVE_LESSON = `${baseUrl}/auth/user/reservation/create`;
export const RESERVE_LESSON_CANCEL = `${baseUrl}/auth/user/reservation/cancel`;
export const RESERVE_LESSON_REFUND = `${baseUrl}/auth/user/reservation/refund`;
export const RESERVE_LESSON_CHANGE_SCHEDULE = `${baseUrl}/auth/user/reservation/change-schedule`;
export const RESERVE_LESSON_NO_DATE = `${baseUrl}/auth/user/reservation/noAvailableDates`;

// * student reservation - group - pack
export const STUDENT_RESERVATION_GROUP_PACK = `${baseUrl}/auth/user/reservations/pack/group/save`;
// * student reservation - group - single
export const STUDENT_RESERVATION_GROUP_SINGLE = `${baseUrl}/auth/user/reservations/single/group/save`;

// * student reservation - individual - single
export const STUDENT_RESERVATION_INDIVIDUAL_SINGLE = `${baseUrl}/auth/user/reservations/single/individual/save`;
// * student reservation - individual - pack
export const STUDENT_RESERVATION_INDIVIDUAL_PACK = `${baseUrl}/auth/user/reservations/pack/individual/save`;
// * get user total points
export const GET_USER_TOTAL_POINTS = `${baseUrl}/auth/user/total/points`;

// * lesson reports
export const SEND_LESSON_REPORT_INDIVIDUAL_SINGLE = `${baseUrl}/auth/expert/reservations/action/individual/report`;
export const SEND_LESSON_REPORT_GROUP_SINGLE = `${baseUrl}/auth/expert/reservations/action/group/single/report`;
export const SEND_LESSON_REPORT_GROUP_PACK = `${baseUrl}/auth/expert/reservations/action/group/pack/report`;

// expert revenue management
export const EXPERT_LESSON_HISTORY = `${baseUrl}/auth/teacher/revenue/lesson/history`;
export const EXPERT_PAYMENT_HISTORY = `${baseUrl}/auth/teacher/revenue/payment/history`;

// * reschedule reservations
export const RESCHEDULE_INDIVIDUAL_SINGLE = `${baseUrl}/auth/user/reservations/single/reschedule`;
export const RESCHEDULE_INDIVIDUAL_PACK = `${baseUrl}/auth/user/reservations/pack/reschedule`;

// * refund
export const REFUND_INDIVIDUAL_SINGLE = `${baseUrl}/auth/user/reservations/single/refund`;
export const REFUND_INDIVIDUAL_PACK = `${baseUrl}/auth/user/reservations/pack/refund`;

// * Rate
export const RATE_SINGLE = `${baseUrl}/auth/user/reservations/single/rate`;
export const RATE_PACK = `${baseUrl}/auth/user/reservations/pack/rate`;

// Top Page with Auth
export const GET_TOP_PAGE_LESSONS_WITH_AUTH = `${baseUrl}/auth/top/lessons`;
export const GET_TOP_PAGE_TEACHERS_WITH_AUTH = `${baseUrl}/top/teachers`;
export const SET_FAVOURITE_LESSON = `${baseUrl}/auth/top/lesson/favourite`;
export const SET_BOOKMARK_TEACHER = `${baseUrl}/auth/top/teachers/bookmark`;

// Top Page without Auth
export const GET_TOP_PAGE_LESSONS = `${baseUrl}/top/lessons`;
export const GET_TOP_PAGE_TEACHERS = `${baseUrl}/top/teachers`;
export const LESSONS_TAGS = `${baseUrl}/top/lessons/tags`;
export const GET_TOP_PAGE_LESSONSBY_TAGS = `${baseUrl}/top/lessons/by-tag`;

export const CONTACT_US = `${baseUrl}/auth/user/contact-us`;
export const RATE_TEACHER = `${baseUrl}/auth/rating/teacher`;
